import { Route } from '@angular/router';

import { HomepageComponent } from './homepage.component';

export const homepageRoute: Route = {
    path: '',
    component: HomepageComponent,
    data: {
        pageTitle: 'pagetitles.homepage'
    }
};
